import { Fragment, useMemo } from 'react'

import {
  Box, Image, NavigationLinkGroup, NestedNavigation, Text,
} from '@domain-group/suit-theme'

import type { AgencyModel, CampaignModel } from '@models/types'

import useCurrentUser from '@hooks/useCurrentUser'

import { getCampaignPermissions, getCampaignType } from '@functions/campaign'

import generateNavigationItems from './utils/generateNavigationItems'

import PlaceholderImageUrl from './assets/placeholder.svg'

type NavigationProps = {
  agency: AgencyModel | {},
  campaign: CampaignModel,
  currentUserPayload: ReturnType<typeof useCurrentUser>,
}

const Navigation = (props: NavigationProps) => {
  const {
    agency,
    campaign,
    currentUserPayload,
    currentUserPayload: { currentUser },
  } = props

  const navigationItems = useMemo(() => {
    const items = generateNavigationItems({
      // @ts-expect-error TS2353
      agency,
      campaign,
      campaignPermissions: getCampaignPermissions({
        user: currentUser,
        campaignType: getCampaignType(campaign),
      }),
      currentUserPayload,
    })

    return items
  // @ts-expect-error TS2339
  }, [agency.cache_key, campaign.cache_key, currentUser.cache_key])

  return (
    <NestedNavigation>
      <Image
        height={190}
        placeholderUrl={PlaceholderImageUrl}
        url={campaign.default_image}
        width="100%"
      />

      <Box flexDirection="column" flexShrink={0} paddingX="large">
        {/* Address */}
        <Box
          borderBottom="1px solid"
          borderColor="lineColor"
          flexDirection="column"
          paddingY="large"
        >
          <Text fontSize="small">
            {campaign.address}
          </Text>

          <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="medium">
            {campaign.suburb_name}
          </Text>
        </Box>
        {/* End Address */}

        {/* Nav */}
        {navigationItems
          && navigationItems.sections.map(section => (
            <Box flexDirection="column" key={section.key} marginTop="large">
              {section.title && (
                <Text
                  fontSize="11px"
                  letterSpacing="1px"
                  marginY="medium"
                  opacity="0.5"
                >
                  {(section.title).toUpperCase()}
                </Text>
              )}

              <Fragment key={section.key}>
                {section.items && section.items.map(item => (
                  <NavigationLinkGroup key={item.key} link={item} secondaryNav sidebarMaximized />
                ))}
              </Fragment>
            </Box>
          ))}
        {/* End Nav */}
      </Box>
    </NestedNavigation>
  )
}

export default Navigation
